<template>
  <v-card outlined elevation="1">
    <!-- Primary content -->
    <v-container fluid class="pb-0 px-4 l-card__content__primary">
      <v-row class="ma-0 d-flex flex-column">
        <span class="l-card__primary__content__text">Produtor</span>
        <span class="l-card__primary__content__value">
          {{ lot["jsonProdutor"] && lot["jsonProdutor"]["nmProdutor"] }}
        </span>
      </v-row>
    </v-container>
    <!-- Secondary content -->
    <v-container fluid class="px-4 pt-1 pb-4 l-card__content__secondary">
      <v-row class="ma-0">
        <span class="l-card__secondary__content__text">Lote</span>
        <span class="l-card__secondary__content__value ml-1">
          {{ lot["nrLoteControle"] }}
        </span>
      </v-row>
      <v-row class="ma-0">
        <span class="l-card__secondary__content__text">Extensionista</span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="l-card__secondary__content__value ml-1">
              {{
                lot["responsavelTecnico"] &&
                lot["responsavelTecnico"]["nmPessoa"]
              }}
            </span>
          </template>
          <span>
            {{
              lot["responsavelTecnico"] && lot["responsavelTecnico"]["nmPessoa"]
            }}
          </span>
        </v-tooltip>
      </v-row>
      <v-row class="ma-0">
        <span class="l-card__secondary__content__text">Cidade</span>
        <span class="l-card__secondary__content__value ml-1">{{
            lot["nmCity"]
                                                             }}</span>
      </v-row>
    </v-container>
    <!-- Info -->
    <v-container fluid class="pa-0 l-card__content__lot-info__container">
      <v-row class="ma-0 px-4 l-card__content__lot-info__row">
        <v-col cols="6" class="pa-0 py-1">
          <v-row class="ma-0">
            <span class="l-card__content__lot-info__text">Gênero</span>
            <span class="l-card__content__lot-info__value">
              {{ lot["sgSexo"] | genderDisplay }}
            </span>
          </v-row>
          <v-row class="ma-0">
            <span class="l-card__content__lot-info__text">Tipo</span>
            <span class="l-card__content__lot-info__value">
              {{ lot["jsonUnidadeExploracao"]["csTipoUnidadeExploracao"] }}
            </span>
          </v-row>
        </v-col>
        
        <v-col cols="6" class="pa-0 py-1">
          <v-row justify="end" class="ma-0">
            <span class="l-card__content__lot-info__text">Distância</span>
            <span
              class="l-card__content__lot-info__value"
              :class="[{
                'km': lotDistance
              }]"
            >
              {{lotDistance}}
            </span>
          </v-row>
          <v-row justify="end" class="ma-0">
            <span class="l-card__content__lot-info__text">Alojamento</span>
            <span class="l-card__content__lot-info__value days">
              {{ accommodationDays }}
            </span>
          </v-row>
          <v-row justify="end" class="ma-0">
            <span
              class="l-card__content__lot-info__text"
              :class="[{
                'error--text': !lot['qtAnimaisDisponiveis']
              }]"
            >
              Disponíveis
            </span>
            <span
              class="l-card__content__lot-info__value"
              :class="[{
                'error--text': !lot['qtAnimaisDisponiveis']
              }]"
            >
              {{lot["qtAnimaisDisponiveis"]}}
            </span>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- Checkboxes -->
    <v-container fluid>
      <v-row class="ma-0 overflow-auto flex-nowrap">
        <div
          v-for="(item, idx) in listLotIndicators"
          :key="lot['idLoteProducao'] + item['dtProjecao']"
          class="pa-1"
        >
          <lot-day-checkbox-card
            v-if="dtProjecaoHasDemand(item['dtProjecao'])"
            v-model="selectedDays"
            :item="item"
            :true-value="{
              stDiaAlocado: `qtDia${idx + 1}`,
              dtAlocado: item['dtProjecao'],
              nrPesoDia: item['nrPeso'],
            }"
          />
        </div>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import moment from "moment"
import {mapState} from "vuex"
import LotDayCheckboxCard from "@/modules/programacaoAbate/components/LotTab/LotDayCheckboxCard"

export default {
  name: "LotCard",
  components: {LotDayCheckboxCard},
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: null,
    lot: {
      type: Object,
      required: true
    },
    cdPlantaAbate: {
      type: Number
    }
  },
  data: () => ({
    selectedDays: []
  }),
  filters: {
    genderDisplay(value) {
      switch (value) {
        case "MA":
          return "Macho"
        case "FE":
          return "Fêmea"
        case "MI":
          return "Misto"
        default:
          return ""
      }
    },
  },
  methods: {
     dtProjecaoHasDemand(value) {
      const idx = this.listDatesWithDemand.findIndex(obj => obj["text"] === value)
      return idx > -1
    }
  },
  computed: {
    lotDistance() {
      const foundItem = this.slaughterPlantEstablishments.find(i => {
        return (
          i["cdEstabelecimento"] === this.lot["cdEstabelecimento"] &&
          i["cdPlantaAbate"] === this.cdPlantaAbate
        )
      })
      if (!foundItem) return ""
      
      return foundItem["nrValor"]
    },
    accommodationDays() {
      let date = this.lot["dtAlojamento"]
      if (!date) return ""
      date = moment(date)
      const now = moment(moment.now())
      return now.diff(date, "days")
    },
    listLotIndicators() {
      if (!this.lot['listaIndicadores']) return []
      return this.lot['listaIndicadores']
      // .filter((item) => {
      //   const idx = this.listDatesWithDemand.findIndex(obj => obj["text"] === item["dtProjecao"])
      //   return idx > -1
      // })
    },
    ...mapState("programacaoAbate", ["slaughterPlantEstablishments", "listDatesWithDemand"])
  },
  watch: {
    selectedDays(newValue) {
      this.$emit("change", newValue)
    },
    value: {
      deep: true,
      handler(newValue) {
        this.selectedDays = newValue
      }
    }
  }
}
</script>

<style scoped lang="scss">
.l-card__content__secondary {
  line-height: 1.3em;
  
  .row {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }
}

.l-card__primary__content__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7b9596;
}

.l-card__primary__content__value {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565c;
}

.l-card__secondary__content__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #37565c;
}

.l-card__secondary__content__value {
  font: normal normal bold 10px/13px Roboto;
  letter-spacing: 0;
  color: #37565c;
}

.l-card__content__lot-info__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #10303d;
}

.l-card__content__lot-info__value {
  text-align: right;
  font: normal normal bold 10px/13px Roboto;
  letter-spacing: 0;
  color: #10303d;
  padding-left: 5px;
  
  &.km::after {
    content: "Km";
    font: normal normal bold 10px/13px Roboto;
    letter-spacing: 0;
    color: #10303d;
    text-transform: none;
  }
  
  &.kg::after {
    content: "Kg";
    font: normal normal bold 10px/13px Roboto;
    letter-spacing: 0;
    color: #10303d;
    text-transform: none;
  }
  
  &.days::after {
    content: "d";
    font: normal normal bold 10px/13px Roboto;
    letter-spacing: 0;
    color: #10303d;
    text-transform: none;
  }
}

.l-card__content__lot-info__container {
  background: #f7f7f7 0 0 no-repeat padding-box;
  opacity: 1;
}

.l-card__content__lot-info__row {
  .col {
    .row {
      margin: 10px 0 !important;
    }
  }
}
</style>
